module.exports = __webpack_public_path__ + "img/3.16143ece.jpg";